import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

if ('serviceWorker' in navigator) {
    if (process.env.NODE_ENV === 'production') {
        window.addEventListener('load', () => {
            navigator.serviceWorker
                .register('/service-worker.js')
                .then((registration) => {
                    // iOS PWAs resume from memory for days without reloading — the
                    // old bundle keeps running long after a deploy. Check for a new
                    // service worker every time the app comes back to the
                    // foreground, and reload once the new one takes control.
                    document.addEventListener('visibilitychange', () => {
                        if (document.visibilityState === 'visible') {
                            registration.update().catch(() => undefined)
                        }
                    })
                })
                .catch(() => undefined)

            let refreshing = false
            navigator.serviceWorker.addEventListener('controllerchange', () => {
                if (refreshing) return
                refreshing = true
                window.location.reload()
            })
        })
    } else {
        // NEVER register the SW in development: its cache-first strategy pins
        // webpack's unhashed bundle.js forever — stale code, HMR reload loops
        // and blank pages. Also self-heal machines that already registered it.
        window.addEventListener('load', () => {
            navigator.serviceWorker
                .getRegistrations()
                .then((regs) => regs.forEach((r) => r.unregister()))
                .catch(() => undefined)
        })
    }
}
